import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import IdealStudio from "../../../core/editor/main";
import i18n from "i18next";
import PluginRibbon from "../nav_bar/plugin_ribbon/PluginRibbon";
import { updateBox } from "../../../common/actions";
import PropTypes from "prop-types";
/**
 * Configuration modal for plugins that require it
 */
export default class PluginConfigModal extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{show: boolean, pluginActive: string, reason: null, disabledButton: boolean}}
     */
    this.state = {
      show: false,
      pluginActive: "",
      reason: null,
      disabledButton: false,
      currentStep: 1,
    };
    this.pluginInsertionRef = React.createRef();
  }

  /**
   * Before component updates
   * Gets config updates from Plugin API
   * @param nextProps
   * @param nextState
   */
  componentWillUpdate(nextProps, nextState) {
    /*
        if(this.state.show === false && nextState.show === true &&
            IdealStudio.Plugins.get(nextProps.name) !== undefined &&
            IdealStudio.Plugins.get(nextState.pluginActive).getConfig().needsConfirmation &&
            nextState.disabledButton !== true) {
            this.setState({ disabledButton: true });
        }

        if (nextState.disabledButton === true &&
            IdealStudio.Plugins.get(this.state.pluginActive) !== undefined &&
            (IdealStudio.Plugins.get(this.state.pluginActive).getConfig().needsConfirmation &&
            !this.props.state.editing)) {
            this.setState({ disabledButton: false });
        }*/
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.id && nextProps.id) {
      this.setState({ pluginState: nextProps.state });
    }
  }
  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    let props = {
      openFileModal: this.props.openFileModal,
      fileModalResult: this.props.fileModalResult,
    };
    let steps = [];
    let stepsnumber = 0;

    let component = null;
    if (this.props.name) {
      let template = IdealStudio.Plugins.get(this.props.name).getConfigTemplate(
        this.props.id,
        this.state.pluginState,
        (pluginState) => {
          this.setState({ pluginState });
        },
        { ...props, step: this.state.currentStep }
      );
      if (template) {
        component = template.component;
        stepsnumber = template.n_steps;
      }
    }
    if (!this.props.id) {
      return null;
    }

    return (
      <div
        className="pageModal pluginconfig modal show"
        style={{
          display: "block",
          zIndex: 3000000, // dialog band (see style.scss)
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            this.props.closeConfigModal();
            this.setState({ currentStep: 1 });
          }
        }}
      >
        <div
          className="modal-dialog modal-lg"
          style={{
            margin: "30px auto",
            maxWidth: "900px",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          >
            <div className="modal-header">
              <h4 className="modal-title">{i18n.t("plugin_config")}</h4>
            </div>
            <div className="modal-body">
              <Row>{this.props.id ? component : null}</Row>
              <div id="plugin_config_info" />
            </div>
            <div className="modal-footer">
              <Button
                variant="secondary"
                onClick={(e) => {
                  this.props.closeConfigModal();
                  this.setState({ currentStep: 1 });
                }}
              >
                {i18n.t("Cancel")}
              </Button>
              {this.state.currentStep > 1 ? (
                <Button
                  variant="secondary"
                  onClick={(e) => {
                    this.setState({ currentStep: this.state.currentStep - 1 });
                  }}
                >
                  {"< " + i18n.t("step_previous")}
                </Button>
              ) : null}
              <Button
                ref={this.pluginInsertionRef}
                variant="primary"
                id="insert_plugin_config_modal"
                disabled={this.state.disabledButton}
                onClick={(e) => {
                  if (this.state.currentStep < stepsnumber) {
                    this.setState({ currentStep: this.state.currentStep + 1 });
                  } else {
                    this.props.updatePluginToolbar(this.props.id, this.state.pluginState);
                    this.props.closeConfigModal();
                    this.setState({ currentStep: 1 });
                  }
                }}
              >
                {this.state.currentStep < stepsnumber
                  ? i18n.t("step_next") + " >"
                  : i18n.t("confirm_changes")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /**
   * After component mounts.
   * Gets configuration from Plugin API
   */
}
PluginConfigModal.propTypes = {
  /**
   * Selected plugin id
   */
  id: PropTypes.any.isRequired,
  /**
   * Selected plugin name
   */
  name: PropTypes.string.isRequired,
  /**
   * Selected plugin state
   */
  state: PropTypes.object.isRequired,
  /**
   * Closes configuration modal
   */
  closeConfigModal: PropTypes.func,
  /**
   * Updates plugin toolbar
   */
  updatePluginToolbar: PropTypes.func.isRequired,
  /**
   * Last files uploaded to server or searched in modal
   */
  fileModalResult: PropTypes.object,
  /**
   * Function that opens the file search modal
   */
  openFileModal: PropTypes.func.isRequired,
};
